<template>
  <div>
    <el-form ref="questionnaire" label-position="left" :model="questionnaire">
      <el-row
        type="flex"
        align="top"
        :gutter="30"
        v-for="(item, index) in questionnaire.questionnaires"
        :key="index"
      >
        <el-col :span="4">
          <div class="questionnaire-div">{{ index + 1 }}</div>
        </el-col>
        <el-col :span="20" >
          <el-form-item>
            <div slot="label">
              <div v-if="index == 3"  class="wordWrap">
                  {{question}}
              </div>
              <div v-else class="wordWrap">
                  {{ item.question }}
              </div>
            </div>
            <el-input :disabled="isView" type="textarea" v-model="item.answer"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-if="!isView && !adminEdit"
        class="from-button-group"
        label=""
        style="text-align: center"
      >
        <el-button type="success" @click="onBack"> 返回 Back </el-button>
        <el-button type="primary" @click="onSave"> 儲存 Save </el-button>
        <el-button type="primary" @click="onSaveAndContinue">
          下一頁 Next
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    questionnaire: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    adminEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
       question:'申請人期望在本校就讀國際文憑課程學到甚麼? \n What does the applicant expect to learn from our school during the study of the IB Diploma?'
    };
  },
  methods: {
    onBack() {
      this.$emit("onQuestionnaireBack");
    },
    onSave() {
      this.$emit("onQuestionnaireSave");
    },
    onSaveAndContinue() {
      this.$emit("onQuestionnaireSaveAndContinue");
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-div {
  //正方形
  width: 30px;
  height: 30px;
  background-color: #409eff;
  border-radius: 6px;
  //文字
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}
.el-button--primary{
  width: auto;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  ::v-deep{
    .el-form-item__label{
      line-height: 1.4375rem;
      margin-bottom: 0.625rem;
        white-space:pre-wrap;
        word-wrap:break-word;
        word-break:keep-all;
        word-wrap:break-word;
        overflow-wrap: break-word;
        width: 100%;
    }
  }
  .from-button-group .el-button{
    margin-bottom: 0.625rem;
  }
  .from-button-group .el-button{
    margin-left: 0;
  }
}
</style>